import React from 'react';
import { IProps } from './types';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setInsureHelperModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';

const InsureHelperModal: React.FC<IProps> = (props) => {
  const handleClose = () => {
    props.setInsureHelperModalVisible(false);
  };

  return (
    <>
      {props.modal.insureHelperModalVisible && (
        <div className="insure-helper-modal">
          <Modal
            visible={props.modal.insureHelperModalVisible}
            // title={props.title ?? '如何填寫'}
            confirmButton={false}
            onCancel={handleClose}
          >
            <div className="insure-helper-modal__example-image" />
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setInsureHelperModalVisible: (visible: boolean) => dispatch(setInsureHelperModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(InsureHelperModal);
